import { z } from "zod";

/** E.164 international phone number, matching Authentica's expected format (e.g. +966551234567). */
export const e164PhoneSchema = z.string().regex(/^\+[1-9]\d{1,14}$/, "Enter a phone number in international format (e.g. +9665XXXXXXXX)");

export const otpMethodSchema = z.enum(["sms", "whatsapp", "email"]);

export const requestOtpSchema = z
  .object({
    method: otpMethodSchema,
    phone: e164PhoneSchema.optional(),
    email: z.string().trim().email().optional(),
  })
  .refine((v) => (v.method === "email" ? !!v.email : !!v.phone), {
    message: "A phone number is required for sms/whatsapp; an email is required for email",
    path: ["phone"],
  });

export type RequestOtpInput = z.infer<typeof requestOtpSchema>;

export const verifyOtpSchema = z
  .object({
    otp: z.string().trim().regex(/^\d{4,8}$/, "Enter the verification code"),
    phone: e164PhoneSchema.optional(),
    email: z.string().trim().email().optional(),
  })
  .refine((v) => !!v.phone || !!v.email, { message: "A phone or email is required", path: ["phone"] });

export type VerifyOtpInput = z.infer<typeof verifyOtpSchema>;
